import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';
import { OnlineSchedulingParams } from 'interfaces/onlineSchedulingParams';

export interface TrafficBySourceRow {
  source: string | null;
  openedWidget: number;
  onlineAppts: number;
  totalAppts: number;
  shows: number;
  totalNewPatients: number;
  totalExistingPatients: number;
  totalProduction: number;
  productionPerAppt: number;
}

export interface TrafficBySourceDetail {
  trafficBySource: TrafficBySourceRow[];
  totals: TrafficBySourceRow;
  period: {
    startDate: string;
    endDate: string;
  };
}

export interface RoiTrafficBySourceData {
  periodData: TrafficBySourceDetail;
}

const useRoiTrafficBySource = (params: OnlineSchedulingParams) => {
  const storedId = loadSelectedClinicId();
  const clinicIds = params.clinicIds ?? [storedId];
  const headerClinicId = storedId || clinicIds[0];
  const query =
    params.startDate && params.endDate
      ? new URLSearchParams({
          startDate: params.startDate,
          endDate: params.endDate,
          hourType: params.hourType,
        }).toString()
      : '';

  const url =
    params.startDate && params.endDate
      ? `/rois/traffic-by-source?${query}`
      : null;

  const { data, error, isValidating, mutate } = useSWR(
    url && headerClinicId ? [url, clinicIds] : null,
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get<RoiTrafficBySourceData>(url, {
        params: { clinicIds },
        headers: { 'X-ClinicId': headerClinicId },
      });
      return response.data;
    }
  );

  if (!params.startDate || !params.endDate) {
    return {
      data: null,
      error: undefined,
      isLoading: false,
      isValidating: false,
      mutate: async () => {},
    };
  }

  return {
    data,
    error,
    isLoading: !data && !error,
    isValidating,
    mutate,
  };
};

export default useRoiTrafficBySource;
